export default {
    resetStateMutation() {

    },
    setSearchFormOpen(state) {
        state.searchFormIsOpen = true;
        state.gridIsOpen = false;
    },
    setSearchFormClose(state) {
        state.searchFormIsOpen = false;
        state.gridIsOpen = true;
    }
}
